import { createAction, props } from '@ngrx/store';
import { SpecialActions } from './models';

export const startSpecialAction = createAction('[Search] Do Special Action', props<{ action: SpecialActions }>());
